export default {
  metadata: {
    title: 'Detailed information regarding security, monitoring and encryption. - artificial',
    desc: `We’re serious about giving your business peace of mind. That's why we use world-class monitoring, strict access controls and high-level encryption.`,
  },
  ArHeroHeader: {
    title: 'Security',
  },
  ArTextContent: {
    content: [
      {
        tag: 'p',
        options: {
          innerText: 'Nothing is more important to us than your security. Sensitive data deserves world-class monitoring, strict access controls and high-level encryption. At Artificial, we’re serious about giving your business peace of mind.',
        },
      },
      {
        tag: 'h2',
        options: {
          innerText: 'HTTPS for Secure Connections',
        },
      },
      {
        tag: 'p',
        options: {
          innerText: 'All traffic between our APIs and client-facing applications is encrypted and served over HTTPS (enforced with HSTS) using the strongest TLS security policies. We also submit all of our applications to external penetration testing, so you can trust your data is safe.',
        },
      },
      {
        tag: 'h2',
        options: {
          innerText: 'Access Control Lists',
        },
      },
      {
        tag: 'p',
        options: {
          innerText: 'We deploy group-based and role-based access control policies for data access on both the infrastructure and application level. We also keep a full audit log of administrative and user access.',
        },
      },
      {
        tag: 'h2',
        options: {
          innerText: 'Encryption of Sensitive Data',
        },
      },
      {
        tag: 'p',
        options: {
          innerText: 'All sensitive data in our applications is encrypted at rest using AES-256 Ciphers. We only keep sensitive data on privately accessible servers, never public.',
        },
      },
      {
        tag: 'h2',
        options: {
          innerText: 'Alerting & Monitoring',
        },
      },
      {
        tag: 'p',
        options: {
          innerText: "Our applications are monitored and alerts are automatically triggered if something looks out of the ordinary. This tells us if there's a problem, so you don't have to.",
        },
      },
      {
        tag: 'h2',
        options: {
          innerText: 'Infrastructure Isolation and Protection',
        },
      },
      {
        tag: 'p',
        options: {
          innerText: 'Each of our applications is deployed within the AWS Cloud and is isolated on its own resources - within its own account and inside its own VPC. Sensitive resources, such as databases, are only able to communicate through private connections and are not available for access on the outside internet.',
        },
      },
      { tag: 'br' },
      { tag: 'br' },
      { tag: 'br' },
    ],
  },
}
